/**
 * Returns copy specific to various closing pages
 *
 * @param isAgent - return copy for agent experience
 *
 */
export const text = {
  closingPage: {
    pastDeadlineToChangeCloseOfEscrow: (isAgent: boolean) =>
      `${isAgent ? 'Your client’s' : 'Your'} close date is locked since it’s after 90 days since 
        the contract has been signed. Contact your Opendoor Expert to request change.`,
  },
  disclosuresPage: {
    hvacRoofInfo: {
      claimDetails: 'Please provide details about the claim',
      description: (isAgent: boolean) =>
        `Next, tell us about ${isAgent ? 'your client’s' : 'your'} plumbing.`,
      hasFiledInsuranceClaim: (isAgent: boolean) =>
        `${
          isAgent ? 'Has your client' : 'Have you'
        } ever filed a claim for damage to the Property with any insurance provider?`,
      hasPolybutenePiping: (isAgent: boolean) =>
        `Does ${isAgent ? 'your client’s' : 'your'} home have polybutelene piping?`,
      hasRoofStormDamage: (isAgent: boolean) =>
        `Is there any known storm damage to ${isAgent ? 'your client’s' : 'your'} roof?`,
      hasSprinkler: (isAgent: boolean) =>
        `Does ${isAgent ? 'your client’s' : 'your'} home have a sprinkler or irrigation system?`,
      hasSumpPump: (isAgent: boolean) =>
        `Does ${isAgent ? 'your client’s' : 'your'} home have a sump pump?`,
      hasWellWaterSupply: (isAgent: boolean) =>
        `Is ${
          isAgent ? 'your client’s' : 'your'
        } water supply pumped from a private water well on the property?`,
      lastFoundationEvaluation: (isAgent: boolean) =>
        `When is the last time ${
          isAgent ? 'your client had their' : 'you had your'
        } foundation evaluated?`,
      receivedProceedsFromClaim: (isAgent: boolean) =>
        `${
          isAgent ? 'Has your client' : 'Have you'
        } ever received proceeds for a claim for damage to the Property?`,
      sprinklerInWorkingOrder: 'Is the system in working order?',
      sprinklerTimerType: 'Does the system have an automatic or manual timer?',
    },
    serviceAccounts: {
      electricalProvider: (isAgent: boolean) =>
        `Who is ${isAgent ? 'your client’s' : 'your'} electricity provider?`,
      gasProvider: (isAgent: boolean) =>
        `Who is ${isAgent ? 'your client’s' : 'your'} gas provider?`,
      hasGas: (isAgent: boolean) =>
        `${isAgent ? 'Does your client' : 'Do you'} use gas in the home?`,
      hasSewerSepticIssue: (isAgent: boolean) =>
        `Are there any issues, malfunctions or defects with ${
          isAgent ? 'the' : 'your'
        } home’s sewer or septic system?`,
      hasWaterIssue: (isAgent: boolean) =>
        `Are there any existing issues with ${
          isAgent ? 'your client’s' : 'your'
        } water quality, supply or pressure?`,
      septicIssueDetails: 'Please share more details',
      serviceAccountCoolingType: (isAgent: boolean) =>
        `What type of cooling system ${isAgent ? 'does your client' : 'do you'} have in the home?`,
      serviceAccountHeatingType: (isAgent: boolean) =>
        `What type of heating system ${isAgent ? 'does your client' : 'do you'} have in the home?`,
      waterIssueDetails: 'Please share more details',
      waterProvider: (isAgent: boolean) =>
        `Who is ${isAgent ? 'your client’s' : 'your'} water provider?`,
    },
    otherHomeInfo: {
      additionalHomeInformation: (isAgent: boolean) =>
        `Is there any other information ${
          isAgent ? 'your client would' : 'you’d'
        } like to share with the future homeowner?`,
      disputeDetails: 'Please share more details',
      hasDispute:
        'Do you know of any litigation or disputes involving the property (common examples: property line, HOA, insurance claim, probate, divorce)?',
      hasRecentPlumbingRepairs: (isAgent: boolean) =>
        `${
          isAgent ? 'Has your client' : 'Have you'
        } had any plumbing repairs in the home within the last 5 years?`,
      hasSharedProperty: (isAgent: boolean) =>
        isAgent
          ? `Does any part of your client’s home (fence, deck, wall) encroach on a neighboring property, or does your client have shared responsibility for maintaining any part of the home with a neighbor?`
          : `Does any part of your home (fence, deck, wall) encroach on a neighboring property, or do you have shared responsibility for maintaining any part of your home with a neighbor?`,
      hasWaterDamage: (isAgent: boolean) =>
        `Does ${isAgent ? 'your client’s' : 'your'} home have any water damage or leaks?`,
      mailDetails: (isAgent: boolean) =>
        `How ${
          isAgent ? 'does your client get their' : 'do you get your'
        } mail? (if there’s a mailbox number, please provide it)`,
      occupancyStatusAtAcquisition: 'Please describe the current occupancy of the home:',
      otherOccupancyStatusAtAcquisition: 'Please provide more details',
      recentPlumbingRepairsDetails: 'Please share more details',
      recyclingCollectionInfo: (isAgent: boolean) =>
        `Who collects ${
          isAgent ? 'your client’s' : 'your'
        } recycling and what day is it                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 collected?`,
      sharedPropertyDetails: 'Please share more details',
      trashCollectionInfo: (isAgent: boolean) =>
        `Who collects ${isAgent ? 'your client’s' : 'your'} garbage and what day is it collected?`,
      waterDamageDetails: 'Please share more details',
    },
  },
};
